module.exports = __webpack_public_path__ + "img/logo_outline.af1e0d8f.svg";